<template>
  <b-card header="Order Items" :header-bg-variant=" (!!invalidItems && invalidItems.length > 0 ? 'danger' : 'default')">
    <section v-if="loading" class="card-loader">
      <i class="fas fa-spinner fa-spin fa-3x"></i>
    </section>
    <div  style="overflow-y: scroll; height: 16rem;">
    <table class="table">
    <thead>
      <tr>
        <th style="width: 9rem;">&nbsp;</th>
        <th>SKU</th>
        <th>Qty</th>
        <th>$</th>
        <th>Weight (lbs)</th>
        <th colspan="3">Dimensions (in)</th>
      </tr>
    </thead>
    <tbody>
      <ShippingItem v-for="item, ix in items" :item="item" :key="ix" :index="ix" @delete-ship-item="deleteItem" @edit-special="showStringModal"/>
    </tbody>
    </table>
    </div>

    <b-button
      block
      class="mt-2"
      variant="success"
      @click="addItem()"
    >
    +
    </b-button>

    <b-modal v-if="items" ref="multipackModal" size="lg" title="Special Shipping Options" hide-footer>
      <pack-modal
        :index="modal.item_index"
        :special="special"
        @stringaltered="submitChange"
        @resetSpecial="resetSpecial"/>
    </b-modal>
  </b-card>
</template>

<script>
import ShippingItem from './ShippingItem';
import PackModal from './PackModal'

export default {
  name: 'Items',
  components: {
    ShippingItem,
    PackModal,
  },
  props: {
    items: {type: Array, default() { return []; }},
    specials: {type: Array, default() { return []; }},
    loading: { type: Boolean, default: false },
    invalidItems: { type: Array, default() { return [] } },
  },
  data() {
    return {
      modal: {
        texts: [],
        show: false,
        item_index: 0,
      },
      pack_edits: [],
      special: [],
    }
  },
  computed: {
  },
  methods: {
    addItem() {
      const blank_item = {
        sku: '',
        quantity: 1,
        weight: 0,
        dimensions: [0,0,0],
        value: 0,
      };
      this.items.push(blank_item);
    },
    deleteItem(ix) {
      this.specials.splice(ix, 1);
      this.items.splice(ix, 1);
    },
    showStringModal(ix) {
      this.modal.item_index = ix;

      this.special = this.items[ix].special;
      this.$refs.multipackModal.show();

    },
    submitChange(multi_strings) {
      this.items[this.modal.item_index].special = null;
      if (multi_strings != 'none') {
        this.items[this.modal.item_index].special = multi_strings;
      }
      this.$refs.multipackModal.hide();
    },
    resetSpecial(index) {
      this.items[index].special = this.specials[index];
      this.special = this.items[index].special;
    },
  }
}
</script>

<style>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pack-and-ship/Items.vue